class ProductCarouselControls {
  constructor(element) {
    if (element.dataset.carouselControlsInit === 'true') return;
    element.dataset.carouselControlsInit = 'true';

    this.element = element;
    this.progressBar = element.querySelector('[data-progress]');
    this.rafId = 0;

    this.init();
  }

  init() {
    this.slideshow = this.element.closest('slideshow-component');
    if (!this.slideshow) return;

    this.scroller = this.slideshow.querySelector('slideshow-slides');
    if (!this.scroller) return;

    this.boundUpdate = () => this.scheduleUpdate();
    this.scroller.addEventListener('scroll', this.boundUpdate, { passive: true });
    this.slideshow.addEventListener('slideshow:select', this.boundUpdate);

    this.resizeObserver = new ResizeObserver(this.boundUpdate);
    this.resizeObserver.observe(this.scroller);

    requestAnimationFrame(() => this.render());
  }

  scheduleUpdate() {
    if (this.rafId) return;

    this.rafId = requestAnimationFrame(() => {
      this.rafId = 0;
      this.render();
    });
  }

  render() {
    if (!this.progressBar || !this.scroller) return;

    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const scrolled = Math.abs(this.scroller.scrollLeft);
    const progress = maxScroll <= 0 ? 100 : (scrolled / maxScroll) * 100;

    this.progressBar.style.width = `${Math.min(Math.max(progress, 0), 100)}%`;
  }
}

document.querySelectorAll('.product-carousel-controls').forEach((el) => {
  new ProductCarouselControls(el);
});

if (typeof MutationObserver !== 'undefined') {
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          if (node.classList?.contains('product-carousel-controls')) {
            new ProductCarouselControls(node);
          }
          node.querySelectorAll?.('.product-carousel-controls').forEach((el) => {
            new ProductCarouselControls(el);
          });
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
}
